// Styles
import styles from './Footer.module.css';
import { logo } from './logo';

// Types
type FooterComponentProps = {
    name: string;
    version: string;
};

/**
 * @param props FooterComponentProps
 * @returns
 */
export default function FooterComponent(props: FooterComponentProps) {
    return (
        <footer className={styles.footer}>
            <div className={styles.version}>
                <span>
                    {props.name}@{props.version}
                </span>
                <span
                    className={styles.logo}
                    dangerouslySetInnerHTML={{
                        __html: logo,
                    }}></span>
            </div>
        </footer>
    );
}
